<div class="card shadow-sm">
  <div class="card-header bg-white py-3">
    <h5 class="card-title m-0 font-weight-bold text-primary">Tạo QR Thanh Toán</h5>
  </div>

  <div class="card-body p-4">
    <form [formGroup]="orderForm">
      <div class="row" formGroupName="storeInfo">
        <!-- Cột trái (1/3): Nhập thông tin -->
        <div class="col-md-4 border-right pr-md-4">
          <h6 class="mb-3 font-weight-bold">Thông tin thanh toán</h6>

          <!-- Nhập Số tài khoản -->
          <div class="form-group mb-3">
            <label class="required_label">{{ "Số tài khoản" | translate }}</label>
            <input
              type="text"
              class="form-control"
              formControlName="qrAccount"
              placeholder="Nhập số tài khoản"
              (blur)="onInputBlur()"
              [ngClass]="{
                'is-invalid': submitted && storeInfo.get('qrAccount')?.errors
              }"
            />
            <div
              *ngIf="submitted && storeInfo.get('qrAccount')?.errors"
              class="invalid-feedback"
            >
              Vui lòng nhập số tài khoản
            </div>
          </div>

          <!-- Tên chủ tài khoản -->
          <div class="form-group mb-3">
            <label>{{ "Chủ tài khoản" | translate }}</label>
            <input
              type="text"
              class="form-control bg-light"
              formControlName="accountOwner"
              placeholder="Tên chủ tài khoản tự động hiển thị"
              readonly
            />
          </div>

          <!-- Nhập Mã QR String -->
          <div class="form-group mb-3">
            <label class="required_label">{{ "Mã QR String" | translate }}</label>
            <textarea
              class="form-control"
              rows="6"
              formControlName="qrString"
              placeholder="Nhập chuỗi VietQR / QR String..."
              [ngClass]="{
                'is-invalid': submitted && storeInfo.get('qrString')?.errors
              }"
            ></textarea>
            <div
              *ngIf="submitted && storeInfo.get('qrString')?.errors"
              class="invalid-feedback"
            >
              Vui lòng nhập mã QR string
            </div>
          </div>
        </div>

        <!-- Cột phải (2/3): Khối QR giữ nguyên 100% HTML Base của bạn -->
        <div class="col-md-8">
          <div class="form-group row col-md-12 m-0">
            <div class="col-md-12 d-block justify-content-center">
              <div class="d-flex justify-content-center">
                <div
                  class="borderQR d-flex flex-column align-items-center"
                  *ngIf="qrStringValue"
                  #qrContainer
                >
                  <div class="qr-with-text canvas-container">
                    <qr-code
                      class="custom-qr-code"
                      [value]="qrStringValue"
                      [size]="400"
                      [errorCorrectionLevel]="'M'"
                    >
                    </qr-code>
                    <div class="text-center user-info" *ngIf="qrStringValue">
                      <h3
                        class="account-name"
                        [ngClass]="{
                          'long-name': accountOwnerValue.length > 25,
                          'very-long-name': accountOwnerValue.length > 35
                        }"
                      >
                        {{ accountOwnerValue }}
                      </h3>

                      <h3
                        class="account-number"
                        [ngClass]="{
                          'long-name': accountOwnerValue.length > 25,
                          'very-long-name': accountOwnerValue.length > 35
                        }"
                      >
                        {{ qrAccountValue }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Nút bấm giữ chuẩn lớp btn-viettel -->
              <div class="d-flex justify-content-center mt-3" *ngIf="qrStringValue">
                <div class="col-12 col-md-5 p-0">
                  <button class="btn-viettel col" (click)="downloadQRCode()">
                    <span class="m-auto">Tải xuống mã QR</span>
                  </button>
                  <button class="btn-viettel col mt-2" (click)="printQRCode()">
                    In QR Code
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>